/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import {api} from '../api';

const namespace = 'institutions';
export const FETCH_INSTITUTIONS_REQUEST = `${namespace}/FETCH_INSTITUTIONS_REQUEST`;
export const FETCH_INSTITUTIONS_REQUEST_SUCCESS = `${namespace}/FETCH_INSTITUTIONS_REQUEST_SUCCESS`;

export const FETCH_INSTITUTION_REQUEST = `${namespace}/FETCH_INSTITUTION_REQUEST`;
export const FETCH_INSTITUTION_SUCCESS = `${namespace}/FETCH_INSTITUTION_SUCCESS`;

export const ADD_INSTITUTION = `${namespace}/ADD_INSTITUTION`;

export const CHANGE_CONTEXT_INSTITUTION_REQUEST = `${namespace}/CHANGE_CONTEXT_INSTITUTION_REQUEST`;
export const CHANGE_CONTEXT_INSTITUTION_REQUEST_SUCCESS = `${namespace}/CHANGE_CONTEXT_INSTITUTION_REQUEST_SUCCESS`;

/**
 * Action fired when a user requests authorization to manage an institution.
 * @type {string}
 */
export const AUTHORIZE_INSTITUTIONS_REQUEST = `${namespace}/AUTHORIZE_INSTITUTIONS_REQUEST`;

/**
 * Action fired when a user's request for institution authorization fails.
 * @type {string}
 */
export const AUTHORIZE_INSTITUTIONS_FAILURE = `${namespace}/AUTHORIZE_INSTITUTIONS_FAILURE`;

/**
 * Action fired when a user's request for authorization to manage a institution is successful.
 * @type {string}
 */
export const AUTHORIZE_INSTITUTIONS_SUCCESS = `${namespace}/AUTHORIZE_INSTITUTIONS_SUCCESS`;


const USERS_INSTITUTIONS_API_ENDPOINT = 'api/users/current/institutions';

/**
 * Fetch all institutions, then dispatch a FETCH_INSTITUTIONS_SUCCESS action to add them
 * to the application state.
 */
export function fetchInstitutions () {
  return dispatch => {
    dispatch({type: FETCH_INSTITUTIONS_REQUEST});

    return api(USERS_INSTITUTIONS_API_ENDPOINT, {method: 'GET'})
      .then(response => response.json())
      .then((json) => {
        dispatch(requestInstitutionsSuccess(json));
      })
    ;
  };
}

/**
 * Create an action to signal the successful fetch of the user's institutions.
 *
 */
export const requestInstitutionsSuccess = (institutions) => {
  return {
    type: FETCH_INSTITUTIONS_REQUEST_SUCCESS,
    institutions
  };
};


/**
 * Fetch an institution, then dispatch a FETCH_INSTITUTION_SUCCESS action to add it to the
 * app state.
 */
export const fetchInstitution = (id) => {
  return async  (dispatch) => {
    dispatch({type: FETCH_INSTITUTION_REQUEST, payload: {id}});
    const response = await api(`/api/institutions/${id}`, {method: 'GET'});
    if (response.ok) {
      const json = await response.json();
      dispatch({
        type: FETCH_INSTITUTION_SUCCESS,
        payload: {institution: json}
      });
      return json;
    }
    return null;
  };
};



const USERS_CONTEXT_INSTITUTION_API_ENDPOINT = USERS_INSTITUTIONS_API_ENDPOINT + '/current';

/**
 * Switches the user's context institution.
 *
 * @param institution the new context institution.
 * @returns {function(*)}
 */
export const changeContextInstitution = institution => {
  return dispatch => {
    dispatch({type: CHANGE_CONTEXT_INSTITUTION_REQUEST});

    const body = institution ? {body: JSON.stringify(institution)} : {};
    return api(USERS_CONTEXT_INSTITUTION_API_ENDPOINT, {
      method: 'POST',
      ...body
    }).then((response) => {
      if (response.ok) {
        dispatch(changeContextInstitutionAction(institution));
        if (institution) {
          dispatch(addInstitution(institution));
        }
      }
    });
  };
};

/**
 * Create an action to change the context institution.
 *
 * @param institution the new context institution.
 * @returns {function(*)}
 */
export const changeContextInstitutionAction = institution => {
  return {
    type: CHANGE_CONTEXT_INSTITUTION_REQUEST_SUCCESS,
    institution
  };
};

/**
 * Create an action to add an institution to the user's available institutions.
 *
 * @param institution
 * @returns {{type: string, institution: *}}
 */
export const addInstitution = institution => {
  return {
    type: ADD_INSTITUTION,
    institution
  };
};



// WEBPACK FOOTER //
// ./src/institutions/actions.js